<form [formGroup]="form">
  <ifc-base-filter-dialog [form]="form"
                          (confirmed)="onConfirmed($event)">
  <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Client</mat-label>
      <input *ngIf="!data.clients"
             matInput
             formControlName="clientId"
             type="text"
             placeholder="Client">
      <mat-select *ngIf="data.clients"
                  matInput
                  formControlName="clientId"
                  placeholder="Client">
        <mat-option>All</mat-option>
        <mat-option *ngFor="let client of data.clients"
                    [value]="client.id">{{client.name}}</mat-option>
      </mat-select>
      <button type="button"
              *ngIf="form.get('clientId').value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="form.get('clientId').setValue('')">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
  <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Description</mat-label>
      <input matInput
             formControlName="description"
             type="text"
             placeholder="Description">
      <button type="button"
              *ngIf="form.get('description').value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="form.get('description').setValue('')">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

  <ifb-user-fullname-input [fc]="form.get('createdBy')"
               [label]="'Created by'" baseFilterItem></ifb-user-fullname-input>
  <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Status</mat-label>
      <mat-select matInput
                  formControlName="active"
                  placeholder="Status">
        <mat-option>All</mat-option>
        <mat-option value="true">Active</mat-option>
        <mat-option value="false">Inactive</mat-option>
      </mat-select>
    </mat-form-field>

  <ifc-filter-param-date-range-input [fc]="form.get('createdOn')"
                     [label]="'Created on'"
                     (rangeSelected)="createdDateSelected($event)" baseFilterItem>
  </ifc-filter-param-date-range-input>
  <ifc-filter-param-date-range-input [fc]="form.get('expiredOn')"
                     [label]="'Expired on'"
                     (rangeSelected)="expiredDateSelected($event)" baseFilterItem>
  </ifc-filter-param-date-range-input>

    <ng-container *ngIf="form.get('createdOn').value === 'custom'">
  <ifc-datepicker [fc]="form.get('createdOnStart')"
    [label]="'Created date from'" baseFilterItem></ifc-datepicker>
  <ifc-datepicker [fc]="form.get('createdOnEnd')"
    [label]="'Created date to'" baseFilterItem></ifc-datepicker>
    </ng-container>

    <ng-container *ngIf="form.get('expiredOn').value === 'custom'">
  <ifc-datepicker [fc]="form.get('expiresAtStart')"
    [label]="'Expiration date from'" baseFilterItem></ifc-datepicker>
  <ifc-datepicker [fc]="form.get('expiresAtEnd')"
    [label]="'Expiration date to'" baseFilterItem></ifc-datepicker>
    </ng-container>
  </ifc-base-filter-dialog>
</form>
